import * as S from './styles'
import { useObjectives } from './useObjectives'
import { Text } from '@/components'
import { useIsVisibleElement } from '@/hooks/useIsVisibleElement'
import { Objectives } from '@/service/api/casePage'

export type ObjectivesContainerProps = {
  data: Objectives
  color: string
}
export const ObjectivesContainer: React.FC<ObjectivesContainerProps> = ({
  data,
  color,
}) => {
  const { fontSizes, responsive } = useObjectives()

  const { element, elementVisible } = useIsVisibleElement()

  const topCarousel = data.topics.slice(0, Math.trunc(data.topics.length / 2))
  const bottomCarousel = data.topics.filter(
    (topic) => !topCarousel.includes(topic),
  )

  return (
    <S.ObjectivesContainer color={color} elementVisible={elementVisible}>
      <Text color="darkgray" size={fontSizes.title} className="title">
        {data.title}
        <span className="bar" />
      </Text>
      <div className="descriptions" ref={element}>
        <Text color="darkgray" size={fontSizes.description}>
          {data.description1}
        </Text>
        {data.description2 && (
          <Text color="darkgray" size={fontSizes.description}>
            {data.description2}
          </Text>
        )}
      </div>
      {data.doubleCarousel ? (
        <div className="double-carousel">
          <S.Slider responsive={responsive} rtl>
            {topCarousel.map((topic) => (
              <S.ImageCarousel
                key={topic.url}
                src={topic.url}
                alt={topic.alternativeText || ''}
                height={topic.height}
                width={topic.width}
              />
            ))}
          </S.Slider>
          <S.Slider responsive={responsive}>
            {bottomCarousel.map((topic) => (
              <S.ImageCarousel
                key={topic.url}
                src={topic.url}
                alt={topic.alternativeText || ''}
                height={topic.height}
                width={topic.width}
              />
            ))}
          </S.Slider>
        </div>
      ) : (
        <S.Slider responsive={responsive}>
          {data.topics.map((topic) => (
            <S.ImageCarousel
              key={topic.url}
              src={topic.url}
              alt={topic.alternativeText || ''}
              height={topic.height}
              width={topic.width}
            />
          ))}
        </S.Slider>
      )}
    </S.ObjectivesContainer>
  )
}
